// extracted by mini-css-extract-plugin
export default {"root":"_1ljcA","link-overlay":"_10r2X","linkOverlay":"_10r2X"};